import type { ReactNode } from "react";
import { Flex } from "@chakra-ui/react";
import { LIGHT_SHADOW } from "../../styles";

const Card = ({ children }: { children: ReactNode }) => (
  <Flex
    py={{ base: 14, lg: 10 }}
    px={{ base: 4, lg: 10 }}
    rounded={{ base: "none", lg: "xl" }}
    borderBottom={{ base: "1px", lg: "none" }}
    borderColor="greyscale.300"
    bg="white"
    boxShadow={{ base: "none", lg: LIGHT_SHADOW }}
    flexDir="column"
  >
    {children}
  </Flex>
);

export default Card;
